import type { ProductLayoutTree } from 'models/forms/FormResult';
import { ProductVariationValidSyntax } from 'models/productsReferential';
import type { Collection } from 'state/utils/types';

export type EssentialWorkspaceState = {
  quoteId?: string;
  productVariation: Partial<ProductVariationValidSyntax>;
  isFetchingTabContent: boolean;
  isProductValidated: boolean;
  isUnderlyingsResultExpanded?: boolean;
  isPayoffGraphHidden?: boolean;
  productLayout?: ProductLayoutTree;
};

export type EssentialWorkspaceStateMap = Collection<EssentialWorkspaceState>;

export const initialEssentialWorkSpaceState: EssentialWorkspaceStateMap = {};
